import { Component } from 'react'
import { connect } from 'react-redux'
import { withCookies } from 'react-cookie'
import { clearRedux } from "../actions/root";
import { init } from "../actions/session";

var currentTimestamp = require("../version").version

class FetchContainer extends Component {

    state = {
      wasFetching: false,
    }

    componentDidMount(){
      this.checkVersion();
      this.fetchData()
    }

    componentDidUpdate(){
      this.fetchData()
    }

    fetchData = () => {
      const { isLoadingUser } = this.props;
      if(!this.state.wasFetching && !isLoadingUser && this.props?.user?.access_token){
        this.props.init()
          .then(() => this.setState({ wasFetching: true }));
      }
    }

    checkVersion = () => {
      const { cookies, clearRedux } = this.props;
      const currentVersion = cookies.get('version');
      if(currentVersion !== currentTimestamp.toString()){
        this.props.cookies.set('version', currentTimestamp, { expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)) });
        clearRedux();
        window.location.href = window.location.href + (window.location.href.includes('?') ? '&' : '?') + '_t=' + new Date().getTime();
      }
    }

    render() {
      return null;
    }
}


export default connect(
  state => ({
    user: state.oidc.user,
    isLoadingUser: state.oidc.isLoadingUser,
  }),
  { init, clearRedux }
)(withCookies(FetchContainer));
